import React from "react";
import {
    Card,
    CardBody,
    Badge,
    Progress
} from "reactstrap";
import {
    Clock,
    CheckCircle,
    Coffee
} from "react-feather";

const WaitingScreen = ({ remainingTime }) => {

    const formatTime = (seconds) => {
        const min = Math.floor(seconds / 60);
        const sec = seconds % 60;

        return `${String(min).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
    };

    return (
        <Card className="border-0 shadow-sm">

            <CardBody className="text-center py-5">

                <div
                    className="rounded-circle bg-success text-white d-inline-flex align-items-center justify-content-center mb-4"
                    style={{
                        width: "90px",
                        height: "90px"
                    }}
                >
                    <CheckCircle size={42} />
                </div>

                <h3 className="fw-bold">

                    Answer Submitted Successfully

                </h3>

                <p className="text-muted mt-3">

                    Thank you.

                    <br />

                    Your answer has been recorded.

                </p>

                <Badge
                    color="warning"
                    className="px-3 py-2 mt-2"
                >

                    Next Question will be live soon

                </Badge>

                <div className="mt-5">

                    <h5>

                        <Clock
                            size={18}
                            className="me-2"
                        />

                        Starts In

                    </h5>

                    <h2 className="text-primary fw-bold">

                        {formatTime(remainingTime)}

                    </h2>

                </div>

                <Progress
                    animated
                    striped
                    value={100}
                    color="warning"
                    className="mt-4"
                />

                <div className="mt-4 text-muted">

                    <Coffee
                        size={18}
                        className="me-2"
                    />

                    Please wait...

                </div>

            </CardBody>

        </Card>
    );
};

export default WaitingScreen;